import LayoutAdmin from "@/layouts/layoutAdmin.vue";
import salaryComponentRecord from "@/views/module/payroll/payrollSettings/salaryComponentRecord.vue";
import salaryComponent from "@/views/module/payroll/payrollSettings/salaryComponent.vue";
import runSalaryProcess from "@/views/module/payroll/salaryProcess/runSalaryProcess.vue";
import salaryProcessList from "@/views/module/payroll/salaryProcess/salaryProcessList.vue";
import salaryProcessDetails from "@/views/module/payroll/salaryProcess/salaryProcessDetails.vue";
import employeeSalaryDetailsList from "@/views/module/payroll/salaryProcess/employeeSalaryDetailsList.vue";
import employeeSalaryDetails from "@/views/module/payroll/salaryProcess/employeeSalaryDetails.vue";
import prepareAttendance from "@/views/module/payroll/salaryAttendance/prepareAttendance.vue";
import attendanceSummary from "@/views/module/payroll/salaryAttendance/attendanceSummary.vue";
import attendanceSummaryDetails from "@/views/module/payroll/salaryAttendance/attendanceSummaryDetails.vue";
import paymentOrderSetup from "@/views/module/payroll/salaryPayments/paymentOrderSetup.vue";
import bonusType from "@/views/module/payroll/bonusProcess/bonusType.vue";
import runBonusProcess from "@/views/module/payroll/bonusProcess/runBonusProcess.vue";
import paymentOrderList from "@/views/module/payroll/salaryPayments/paymentOrderList.vue";
import bonusProcessList from "@/views/module/payroll/bonusProcess/bonusProcessList.vue";
import employeeBonusDetails from "@/views/module/payroll/bonusProcess/employeeBonusDetails.vue";
import salarySummaryReport from "@/views/module/payroll/salaryReports/salarySummaryReport.vue";
import employeebonuslist from "@/views/module/payroll/bonusProcess/employeeBonusList.vue";
import salaryPayRegisterReport from "@/views/module/payroll/salaryReports/salaryPayRegisterReport.vue";
import salaryBankAdviceReport from "@/views/module/payroll/salaryReports/salaryBankAdviceReport.vue";
import salaryOutstandingReport from "@/views/module/payroll/salaryReports/salaryOutstandingReport.vue";
import employeeSalaryHistoryReport from "@/views/module/payroll/salaryReports/employeeSalaryHistoryReport.vue";
import salaryAgingReport from "@/views/module/payroll/salaryReports/salaryAgingReport.vue";
import taxSummaryReport from "@/views/module/payroll/salaryReports/taxSummaryReport.vue";
import salaryTrendReport from "@/views/module/payroll/salaryReports/salaryTrendReport.vue";
import otIncentiveReport from "@/views/module/payroll/salaryReports/otIncentiveReport.vue";
import fullPayrollLedgerReport from "@/views/module/payroll/salaryReports/fullPayrollLedgerReport.vue";
import employeeBonusList from "@/views/module/payroll/bonusProcess/employeeBonusList.vue";
import paymentOrderInvoice from "@/views/module/payroll/salaryPayments/paymentOrderInvoice.vue";
import monthlySalaryReport from "@/views/module/payroll/salaryReports/monthlySalaryReport.vue";
import bonusProcessReport from "@/views/module/payroll/bonusReports/bonusProcessReport.vue";
import bonusSummaryReport from "@/views/module/payroll/bonusReports/bonusSummaryReport.vue";
import bonusRegisterReport from "@/views/module/payroll/bonusReports/bonusRegisterReport.vue";
import employeeBonusHistory from "@/views/module/payroll/bonusReports/employeeBonusHistory.vue";
import bonusComparativeReport from "@/views/module/payroll/bonusReports/bonusComparativeReport.vue";
import bonusAgingReport from "@/views/module/payroll/bonusReports/bonusAgingReport.vue";
import bonusBankAdvice from "@/views/module/payroll/bonusReports/bonusBankAdvice.vue";
import bonusTrendReport from "@/views/module/payroll/bonusReports/bonusTrendReport.vue";
import bonusPayment from "@/views/module/payroll/bonusPayment/createPaymentOrder.vue";
import bonusPaymentOrderList from "@/views/module/payroll/bonusPayment/bonusPaymentOrderList.vue";
import bonusPaymentOrderInvoice from "@/views/module/payroll/bonusPayment/paymentOrderInvoice.vue";
import allowanceDeductionBreakup from "@/views/module/payroll/salaryReports/allowanceDeductionBreakup.vue";
import addLoan from "@/views/module/payroll/employeeLoan/addLoan.vue";
import loanRecords from "@/views/module/payroll/employeeLoan/loanRecords.vue";
import loanDetails from "@/views/module/payroll/employeeLoan/loanDetails.vue";


export default [
{
    path: "/payroll",
    name: "payroll",
    component: LayoutAdmin,
    meta: {
        UserLoggedIn: true,
        breadcrumb: "Payroll Management",
    },
    children: [
        {
            path: "salary-component-record",
            name: "salary-component-record",
            meta: {
                breadcrumb: ["Payroll Management", "Salary Component Record"],
            },
            component: salaryComponentRecord,
        },
        {
            path: "salary-component",
            name: "salary-component",
            meta: {
                breadcrumb: ["Payroll Management", "Salary Component"],
            },
            component: salaryComponent,
        },
        {
            path: "run-salary-process",
            name: "run-salary-process",
            meta: {
                breadcrumb: ["Payroll Management", "Run Salary Process"],
            },
            component: runSalaryProcess,
        },
        {
            path: "salary-process-list",
            name: "salary-process-list",
            meta: {
                breadcrumb: ["Payroll Management", "Salary Process List"],
            },
            component: salaryProcessList,
        },
        {
            path: "salary-process-details/:id?",
            name: "salary-process-details",
            meta: {
                breadcrumb: ["Payroll Management", "Salary Process Details"],
            },
            component: salaryProcessDetails,
        },
        {
            path: "salary-process",
            redirect: { name: "salary-process-list" }
        },
        {
            path: "employee-salary-details-list",
            name: "employee-salary-details-list",
            meta: {
                breadcrumb: ["Payroll Management", "Employee Salary Details List"],
            },
            component: employeeSalaryDetailsList,
        },
        {
            path: "employee-salary-details/:id?",
            name: "employee-salary-details",
            meta: {
                breadcrumb: ["Payroll Management", "Employee Salary Details"],
            },
            component: employeeSalaryDetails,
        },
        {
            path: "prepare-attendance",
            name: "prepare-attendance",
            meta: {
                breadcrumb: ["Payroll Management", "Prepare Attendance"],
            },
            component: prepareAttendance,
        },
        {
            path: "attendance-summary",
            name: "attendance-summary",
            meta: {
                breadcrumb: ["Payroll Management", "Attendance Summary"],
            },
            component: attendanceSummary,
        },
        {
            path: "attendance-summary-details/:id?",
            name: "attendance-summary-details",
            meta: {
                breadcrumb: ["Payroll Management", "Attendance Summary Details"],
            },
            component: attendanceSummaryDetails,
        },
        {
            path: "bonus-type",
            name: "bonus-type",
            meta: {
                breadcrumb: ["Payroll Management", "Bonus Type"],
            },
            component: bonusType,
        },
        {
            path: "run-bonus-process",
            name: "run-bonus-process",
            meta: {
                breadcrumb: ["Payroll Management", "Run Bonus Process"],
            },
            component: runBonusProcess,
        },
        {
            path: "bonus-process-list",
            name: "bonus-process-list",
            meta: {
                breadcrumb: ["Payroll Management", "Bonus Process List"],
            },
            component: bonusProcessList,
        },

        //Employee Loans
        {
            path: "employee-loan/add",
            name: "add-loan",
            meta: {
                breadcrumb: ["Payroll Management", "Employee Loans", "Add Loan"],
            },
            component: addLoan,
        },
        {
            path: "employee-loan/edit/:id",
            name: "edit-loan",
            meta: {
                breadcrumb: ["Payroll Management", "Employee Loans", "Edit Loan"],
            },
            component: addLoan,
        },
        {
            path: "employee-loans",
            name: "loan-records",
            meta: {
                breadcrumb: ["Payroll Management", "Employee Loans", "Loan Records"],
            },
            component: loanRecords,
        },
        {
            path: "employee-loans/:id",
            name: "loan-details",
            meta: {
                breadcrumb: ["Payroll Management", "Employee Loans", "Loan Details"],
            },
            component: loanDetails,
        },

        //Salary Payments
        {
            path: "create-payment-order",
            name: "create-payment-order",
            meta: {
                breadcrumb: ["Salary Payment", "Create Payment Order"],
            },
            component: paymentOrderSetup,
        },
        {
            path: "payment-order-list",
            name: "payment-order-list",
            meta: {
                breadcrumb: ["Salary Payment", "Payment Order Records"],
            },
            component: paymentOrderList,
        },
        {
            path: "employee-bonus-details",
            name: "employee-bonus-details",
            meta: {
                breadcrumb: ["Payroll Management", "Employee Bonus Details"],
            },
            component: employeebonuslist,
        },
        {
            path: "view-payment-order-invoice",
            name: "view-payment-order-invoice",
            meta: {
                breadcrumb: ["Salary Payment", "Payment Order Invoice"],
            },
            component: paymentOrderInvoice,
        },
        {
            path: 'employee-bonus-details-view/:id',
            name: 'employee-bonus-details-view',
            meta: {
                breadcrumb: ["Payroll Management", "Employee Bonus Details"],
            },
            component: employeeBonusDetails,
        },
        // salary reports
        {
            path: "monthly-salary-sheet",
            name: "monthly-salary-sheet",
            meta: {
                breadcrumb: ["Salary Report", "Monthly Salary Sheet"],
            },
            component: monthlySalaryReport,
        },
        {
            path: "salary-summary-sheet",
            name: "salary-summary-sheet",
            meta: {
                breadcrumb: ["Salary Report", "Salary Summary Sheet"],
            },
            component: salarySummaryReport,
        },
        {
            path: "salary-pay-register",
            name: "salary-pay-register",
            meta: {
                breadcrumb: ["Salary Report", "Salary Pay Register Sheet"],
            },
            component: salaryPayRegisterReport,
        },
        {
            path: "salary-bank-advice",
            name: "salary-bank-advice",
            meta: {
                breadcrumb: ["Salary Report", "Salary Bank Advice Sheet"],
            },
            component: salaryBankAdviceReport,
        },
        {
            path: "salary-outstanding-report",
            name: "salary-outstanding-report",
            meta: {
                breadcrumb: ["Salary Report", "Salary Outstanding Sheet"],
            },
            component: salaryOutstandingReport,
        },
        {
            path: "employee-salary-history",
            name: "employee-salary-history",
            meta: {
                breadcrumb: ["Salary Report", "Employee Salary History sheet"],
            },
            component: employeeSalaryHistoryReport,
        },
        {
            path: "salary-aging-report",
            name: "salary-aging-report",
            meta: {
                breadcrumb: ["Salary Report", "Salary Aging Report"],
            },
            component: salaryAgingReport,
        },
        {
            path: "allowance-deduction-breakup",
            name: "allowance-deduction-breakup",
            meta: {
                breadcrumb: ["Salary Report", "Allowance Deduction Breakup Report"],
            },
            component: allowanceDeductionBreakup,
        },
        {
            path: "tax-summary-report",
            name: "tax-summary-report",
            meta: {
                breadcrumb: ["Salary Report", "Allowance Deduction Breakup Report"],
            },
            component: taxSummaryReport,
        },
        {
            path: "salary-trend-report",
            name: "salary-trend-report",
            meta: {
                breadcrumb: ["Salary Report", "Salary Trend Report"],
            },
            component: salaryTrendReport,
        },
        {
            path: "ot-incentive-report",
            name: "ot-incentive-report",
            meta: {
                breadcrumb: ["Salary Report", "Salary Trend Report"],
            },
            component: otIncentiveReport,
        },
        {
            path: "full-payroll-ledger",
            name: "full-payroll-ledger",
            meta: {
                breadcrumb: ["Salary Report", "Full Payroll Ledger Report"],
            },
            component: fullPayrollLedgerReport,
        },

        // bonus reports
        {
            path: "bonus-process-report",
            name: "bonus-process-report",
            meta: {
                breadcrumb: ["Bonus Reports", "Bonus Process Report"],
            },
            component: bonusProcessReport,
        },
        {
            path: "bonus-summary-register-report",
            name: "bonus-summary-register-report",
            meta: {
                breadcrumb: ["Bonus Reports", "Bonus Summary Report"],
            },
            component: bonusSummaryReport,
        },
        {
            path: "bonus-register-report",
            name: "bonus-register-report",
            meta: {
                breadcrumb: ["Bonus Reports", "Bonus Register"],
            },
            component: bonusRegisterReport,
        },
        {
            path: "employee-bonus-history-report",
            name: "employee-bonus-history-report",
            meta: {
                breadcrumb: ["Bonus Reports", "Employee Bonus History"],
            },
            component: employeeBonusHistory,
        },
        {
            path: "bonus-comparative-report",
            name: "bonus-comparative-report",
            meta: {
                breadcrumb: ["Bonus Reports", "Bonus Comparative Report"],
            },
            component: bonusComparativeReport,
        },
        {
            path: "bonus-aging-report",
            name: "bonus-aging-report",
            meta: {
                breadcrumb: ["Bonus Reports", "Bonus Aging Report"],
            },
            component: bonusAgingReport,
        },
        {
            path: "bonus-bank-advice",
            name: "bonus-bank-advice",
            meta: {
                breadcrumb: ["Bonus Reports", "Bonus Bank Advice"],
            },
            component: bonusBankAdvice,
        },
        {
            path: "bonus-trend-report",
            name: "bonus-trend-report",
            meta: {
                breadcrumb: ["Bonus Reports", "Bonus Trend Report"],
            },
            component: bonusTrendReport,
        },
        {
            path: "create-bonus-payment-order",
            name: "create-bonus-payment-order",
            meta: {
                breadcrumb: ["Payroll Management", "Create Bonus Payment Order"],
            },
            component: bonusPayment,
        },
        {
            path: "bonus-payment-order-list",
            name: "bonus-payment-order-list",
            meta: {
                breadcrumb: ["Payroll Management", "Payment Order List"],
            },
            component: bonusPaymentOrderList,
        },
        {
            path: "bonus-payment-order-invoice",
            name: "bonus-payment-order-invoice",
            meta: {
                breadcrumb: ["Payroll Management", "Payment Order Invoice"],
            },
            component: bonusPaymentOrderInvoice,
        },

        
        
    ],
  },
];
